import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=33c4ac6c&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=33c4ac6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c4ac6c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PaginationModal: require('/home/bitrix/frontend/components/other/PaginationModal.vue').default})
